<template>
    <div class="TQ_width_100p" >


        <tq-on-top-container class="lc_root">


            <tq-img-fill-blur class="TQ_borderRadius_top TQ_center"
                              slot="body"
                              :p_height_s="p_height_s"
                              :key="index_n"
                              v-for="(imageFile,index_n) in pb_imagesFiles_ac"
                              v-show="index_n === currentImageIndex_n"
                              :p_att_s="imageFile.fi_m_nameWithIndex()"
                              :pp_img-url_s="imageFile.fi_url_s"/>

            <tq-image slot="middleRight"
                      v-if="co_showNav_b"
                      :pb_src_r="ass_img_rightArrow_w"
                      class="TQ_width_32px lc_navArrow TQ_clickable"
                      @click.native.prevent="nextImage"/>

            <tq-image slot="middleLeft"
                      v-if="co_showNav_b"
                      :pb_src_r="ass_img_leftArrow_w"
                      class="TQ_width_32px lc_navArrow TQ_clickable"
                      @click.native.prevent="prevImage"/>

            <div slot="bottom" class="lc_bottomBar TQ_direction_ltr TQ_bg_liner_bw" v-if="co_showNav_b" >

                <div class="TQ_inline TQ_padding_0px_2px TQ_borderBox TQ_direction_ltr"
                     :style="{'width' : `calc(100% / ${pb_imagesFiles_ac.length} )`}"
                     :key="index_n"
                     v-for="(imageFile,index_n) in pb_imagesFiles_ac">
                    <div class="TQ_padding_2px TQ_borderRadius lc_imageSlot"></div>
                    <div class="TQ_padding_2px TQ_borderRadius lc_imageSlotLoader" v-if="index_n === currentImageIndex_n"></div>
                </div>
            </div>

        </tq-on-top-container>


    </div>
</template>

<script>
    import {FB_File} from "../../../functions/src/shareCode/Share_S_Classes";
    import {validator_array_typeOf_fb, validator_arrayClass_fb} from "../../../functions/src/shareCode/Share_S_Validator";
    import {date_setTimeout} from "../../scripts/S_Date";
    import TqOnTopContainer from "./TqOnTopContainer";
    import TqProgressBar from "../basic2/TqProgressBar";
    import {ass_img_arrow_left_w, ass_img_arrow_right_w} from "../../assets/scripts/Ass_Files";
    import TqImage from "./TqImage";
    import TqImgFillBlur from "@/components/basic2/TqImgFillBlur";
    import {enum_typeof} from "../../../functions/src/shareCode/Share_S_Enum";

    export default {
        name: "TqImagesSlider",
        components: {TqImgFillBlur, TqImage, TqProgressBar, TqOnTopContainer},
        props:{
            pb_uid_s:{
                type: String,
                require: true,
            },
            pb_imagesFiles_ac:{
                type: Array,
                require: true,
                validator(arr){
                    return validator_arrayClass_fb(arr, FB_File)
                }
            },
            pb_elapsingTime_n:{
                type: Number,
                require: true,
            },
            p_height_s:{
                type: String,
                default: '200px'
            }
        },
        data(){
            return {
                currentImageIndex_n : 0,
                ass_img_leftArrow_w : ass_img_arrow_left_w,
                ass_img_rightArrow_w : ass_img_arrow_right_w
            }
        },
        computed:{
            co_showNav_b(){
                return this.pb_imagesFiles_ac.length > 1
            }
        },
        methods:{
            nextImage(){
                this.currentImageIndex_n = (this.currentImageIndex_n + 1) % this.pb_imagesFiles_ac.length

                date_setTimeout(this.nextImage, this.pb_elapsingTime_n, this.pb_uid_s)

            },
            prevImage(){
                this.currentImageIndex_n = this.currentImageIndex_n - 1

                if(this.currentImageIndex_n < 0)
                    this.currentImageIndex_n = this.pb_imagesFiles_ac.length - 1

                date_setTimeout(this.nextImage, this.pb_elapsingTime_n, this.pb_uid_s)

            }
        },
        mounted(){
            date_setTimeout(this.nextImage, this.pb_elapsingTime_n, this.pb_uid_s)
        },
        activated(){
            this.currentImageIndex_n = 0
        }
    }
</script>

<style scoped lang="scss">

    .lc_navArrow{
        display: none;
    }

    .lc_root:hover{
        .lc_navArrow{
            display: unset;
        }
    }

    .lc_bottomBar{

        padding: 6px 4px 0 4px;

        .lc_imageSlot{
            background: rgba(255, 255, 255, 0.5);
        }

        .lc_imageSlotLoader{
            margin-top: -4px;
            background: white;
            width:1px;

            -webkit-animation:      increase 2s;
            -moz-animation:         increase 2s;
            -o-animation:           increase 2s;
            animation:              increase 2s;
            animation-fill-mode:    forwards;
        }

        @keyframes increase {
            100% {
                width: calc(100% - 4px);
            }
        }
    }





</style>